import Link from "next/link";
import Image from "next/image";
import { Mail, Phone } from "lucide-react";
import { CookiePreferencesButton } from "@/components/common";
import { SITE_CONFIG } from "@/lib/constants";
import { SocialIcons } from "@/components/common/social-icons";
import { AppStoreBadge } from "@/components/common/app-store-badge";

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white">
      <div className="mx-auto max-w-7xl px-4 py-12 pb-24 sm:px-6 md:pb-12 lg:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 md:gap-8 lg:grid-cols-4">
          {/* Logo ve Açıklama */}
          <div>
            <Link href="/" className="inline-block">
              <Image
                src="/logo_mavi.png"
                alt="konakla logosu"
                width={180}
                height={54}
                className="-ml-2 h-14 w-auto"
              />
            </Link>
            {/* Slogan — noktasız; mobilde "kısa süreli"den sonra 2. satıra iner,
                sm+ doğal akış. Metin TEK resmî slogandır (CLAUDE.md §2);
                eski yanlış varyant D-26 ile kaldırıldı. */}
            <p className="text-primary mt-2 text-sm font-medium">
              <span className="block sm:inline">Türkiye&apos;nin komisyonsuz kısa süreli</span>{" "}
              <span className="block sm:inline">konaklama platformu</span>
            </p>

            {/* İletişim Bilgileri */}
            <div className="mt-3 space-y-2">
              <a
                href="mailto:info@konakla.co"
                className="text-muted-foreground hover:text-primary flex items-center gap-2 text-sm transition-colors"
              >
                <Mail className="h-4 w-4" />
                info@konakla.co
              </a>
              <a
                href="tel:+905343016274"
                className="text-muted-foreground hover:text-primary flex items-center gap-2 text-sm transition-colors"
              >
                <Phone className="h-4 w-4" />
                +90 (534) 301 62 74
              </a>
            </div>

            {/* Sosyal Medya İkonları */}
            <SocialIcons className="mt-3" />
          </div>

          {/* Hızlı Linkler */}
          <div>
            <h3 className="text-foreground mb-4 text-sm font-semibold">Hızlı Linkler</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  href="/"
                  className="text-muted-foreground hover:text-primary text-sm transition-colors"
                >
                  Ana Sayfa
                </Link>
              </li>
              <li>
                <Link
                  href="/profile"
                  className="text-muted-foreground hover:text-primary text-sm transition-colors"
                >
                  Profil
                </Link>
              </li>
              <li>
                <Link
                  href="/favorites"
                  className="text-muted-foreground hover:text-primary text-sm transition-colors"
                >
                  Favoriler
                </Link>
              </li>
              <li>
                <Link
                  href="/for-hosts"
                  className="text-muted-foreground hover:text-primary text-sm transition-colors"
                >
                  Evinizi Listeleyin
                </Link>
              </li>
              <li>
                <Link
                  href="/blog"
                  className="text-muted-foreground hover:text-primary text-sm transition-colors"
                >
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          {/* Destek */}
          <div>
            <h3 className="text-foreground mb-4 text-sm font-semibold">Destek</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  href="/about"
                  className="text-muted-foreground hover:text-primary text-sm transition-colors"
                >
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link
                  href="/terms"
                  className="text-muted-foreground hover:text-primary text-sm transition-colors"
                >
                  Kullanım Koşulları
                </Link>
              </li>
              <li>
                <Link
                  href="/partner-agreement"
                  className="text-muted-foreground hover:text-primary text-sm transition-colors"
                >
                  İş Ortağı Sözleşmesi
                </Link>
              </li>
              <li>
                <Link
                  href="/privacy"
                  className="text-muted-foreground hover:text-primary text-sm transition-colors"
                >
                  Gizlilik Politikası
                </Link>
              </li>
              <li>
                <Link
                  href="/kvkk"
                  className="text-muted-foreground hover:text-primary text-sm transition-colors"
                >
                  KVKK Aydınlatma Metni
                </Link>
              </li>
              <li>
                <Link
                  href="/cookies"
                  className="text-muted-foreground hover:text-primary text-sm transition-colors"
                >
                  Çerez Politikası
                </Link>
              </li>
              {/* Rızayı geri alma yolu — çerez banner'ı bir kez kapatılınca
                  kendiliğinden açılmıyor, tek erişim noktası burası. */}
              <li>
                <CookiePreferencesButton className="text-muted-foreground hover:text-primary cursor-pointer text-sm transition-colors" />
              </li>
            </ul>
          </div>

          {/* ETBİS QR ve Rozet */}
          <div>
            <h3 className="text-foreground mb-4 text-sm font-semibold">ETBİS</h3>
            <div className="flex items-start gap-3">
              {/* ETBİS QR kodu — tıklanınca ETBİS doğrulama sayfasına gider */}
              <a
                href="https://etbis.ticaret.gov.tr/tr/SiteSorgulamaSonuc?siteId=9b9c7732-9784-4d10-8afd-2ee426cecd59"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="ETBİS Kayıt Doğrulama"
                className="border-border bg-muted/50 hover:border-primary/30 block h-24 w-24 overflow-hidden rounded-lg border p-1 transition-colors"
              >
                <Image
                  src="/etbis.png"
                  alt="ETBİS QR Kod"
                  width={96}
                  height={96}
                  className="h-full w-full object-contain"
                />
              </a>
              {/* Rozet */}
              <Image
                src="/rozet.png"
                alt="Güvenli Turizm Rozeti"
                width={96}
                height={96}
                className="h-24 w-auto object-contain"
              />
            </div>

            {/* Mobil uygulama — App Store (iOS). Masaüstünde QR+rozetten daha ferah dursun. */}
            <div className="mt-6 md:mt-8">
              <p className="text-muted-foreground mb-2 text-xs font-medium">Mobil uygulama</p>
              <AppStoreBadge />
            </div>
          </div>
        </div>

        {/* PayTR Güvenli Ödeme — alt çizginin hemen üstünde */}
        <div className="mt-12 flex justify-center">
          <Image
            src="/paytr.png"
            alt="PayTR ile güvenli ödeme"
            width={1400}
            height={206}
            className="h-8 w-auto sm:h-10 md:h-12"
          />
        </div>

        {/* Alt Kısım - Disclaimer */}
        <div className="border-border mt-6 border-t pt-8">
          <div className="flex flex-col items-center justify-center gap-4">
            <p className="text-muted-foreground text-center text-xs">
              © {currentYear} {SITE_CONFIG.name}. Tüm hakları saklıdır.
            </p>
          </div>

          {/* Yasal Uyarı */}
          <p className="text-muted-foreground/70 mt-4 text-center text-[10px] leading-relaxed md:text-[11px]">
            konakla, 1618 sayılı &quot;Seyahat Acentaları ve Seyahat Acentaları Birliği Kanunu&quot;
            ile &quot;Seyahat Acentaları Yönetmeliği&quot; kapsamında seyahat acentası değildir ve
            seyahat acentalığı faaliyeti yürütmez. Konaklama hizmeti sunmaz.
          </p>
        </div>
      </div>
    </footer>
  );
}
